module.exports = __webpack_public_path__ + "img/rsi-aris.a762177c.png";